import * as SetActiveProfileTypes from 'src/actions/active-profile/set/Types';
import { SetActiveProfile, SetActiveProfileAction } from 'src/actions/active-profile/set/SetActiveProfile.actions';
import Person from 'src/entities/Person';

export interface SetActiveProfileState {
  activeProfile?: Person;
  loading: boolean;
}

const initialState: SetActiveProfileState = {
  loading: false
};

export function SetActiveProfileReducer(state: SetActiveProfileState = initialState,
                                        action: SetActiveProfileAction): SetActiveProfileState {
  switch (action.type) {
    case SetActiveProfileTypes.SET_ACTIVE_PROFILE:
      const activeProfile: Person = (action as SetActiveProfile).payload;
      return {...state, activeProfile: activeProfile, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user/SetActiveProfileReducer.tsx